// @flow
import React, { Component } from 'react';
import type { Node } from 'react';

// Helpers
import isWindow from 'Common/isWindow';

import Icon from 'Common/Icon';
import styles from 'components/PriceIndicator.scss';

/**
 * <PriceIndicator /> component.
 * @return {class} returns PriceIndicator instance
 */
class PriceIndicator extends Component<*, *> {
  /**
   * @param {object} props - props passed
   */
  constructor(props: Object) {
    super(props);
    this.state = {};
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   *
   */
  static propTypes = {};

  handleClick: (e: SyntheticEvent<HTMLButtonElement>) => void = e => {
    const { item, handleClick, externalUrl } = this.props;
    e.preventDefault();
    handleClick(item);
    isWindow && window.open(externalUrl, '_blank');
  };

  /**
   * Renders <PriceIndicator /> component.
   *
   * @return {JSX} - renders a Price Indicator Data.
   */
  render(): Node {
    return (
      <div className={styles.container}>
        <h4>About our price indicator</h4>
        <Icon
          className={styles.valuationLogo}
          viewBox={'0 0 200 40'}
          iconName={'autotraderValuation'}
          size={'large'}
        />
        <p>
          We&apos; ve compared the seller&apos;s asking price to our Auto Trader
          Valuation and rated this car a great price compared to similar cars on
          the market.
        </p>
        <p>
          Our price labels are intended to act as a guide to help you make an
          informed decision.
        </p>
        <p>
          <strong>How we do the maths</strong> <br />
          Every day we combine and analyse data from millions of vehicles. We
          use this data to work out a car&apos;s current market price, taking
          into account things like make, model, year, mileage, fuel type and
          optional extras.
        </p>
        <p>
          The following is not included in our calculations, but may affect the
          car&apos;s price:
        </p>
        <ul>
          <li>The car&apos;s condition</li>
          <li>The car&apos;s colour</li>
          <li>Regional supply and demand</li>
          <li>Special modifications</li>
          <li>Additional services, warranties and finance deals</li>
          <li>The number of owners</li>
          <li>The car&apos;s service history</li>
        </ul>
        <div className={styles.priceRating}>
          <h5>Price rating categories</h5>
          <ul>
            <li>
              <Icon
                className={styles.priceRatingIndicator}
                iconName={'AT-LOW'}
                size={'large'}
              />
              <div className={styles.priceRatingData}>
                <p>
                  <strong>Low price</strong> <br />
                  Much lower than the market average
                </p>
              </div>
            </li>
            <li>
              <Icon
                className={styles.priceRatingIndicator}
                iconName={'AT-GREAT'}
                size={'large'}
              />
              <div className={styles.priceRatingData}>
                <p>
                  <strong>Great price</strong> <br />
                  Below market average
                </p>
              </div>
            </li>
            <li>
              <Icon
                className={styles.priceRatingIndicator}
                iconName={'AT-GOOD'}
                size={'large'}
              />
              <div className={styles.priceRatingData}>
                <p>
                  <strong>Good price</strong> <br />
                  Close to market average
                </p>
              </div>
            </li>
            <li>
              <Icon
                className={styles.priceRatingIndicator}
                iconName={'AT-FAIR'}
                size={'large'}
              />
              <div className={styles.priceRatingData}>
                <p>
                  <strong>Fair price</strong> <br />
                  Slightly above the market average
                </p>
              </div>
            </li>
            <li>
              <Icon
                className={styles.priceRatingIndicator}
                iconName={'AT-HIGH'}
                size={'large'}
              />
              <div className={styles.priceRatingData}>
                <p>
                  <strong>High price</strong> <br />
                  Above the market average
                </p>
              </div>
            </li>
          </ul>
        </div>
        <p>
          <strong>Why should I buy a higher priced car?</strong>
          <br />
          Higher-priced cars may be in exceedingly good condition, or the seller
          may offer additional benefits like a warranty, which could be why
          it&apos;s priced above market.
        </p>
        <p>
          We recommend you check the description or ask the seller for more
          info.
        </p>
        <ul>
          <li>Cars with no price rating</li>
          <li>Brand new or nearly new</li>
          <li>Rare or classic</li>
          <li>Listed by private sellers</li>
          <li>Priced below £1,500</li>
          <li>Priced above £50,000</li>
          <li>Over 15 years old</li>
          <li>Cat C/D/S/N</li>
          <li>Imported</li>
          <li>Want to be sure you&apos;re paying a fair price?</li>
        </ul>
      </div>
    );
  }
}

export default PriceIndicator;



// WEBPACK FOOTER //
// ./src/Common/PriceIndicator/index.js